import { useEffect, useId, useState } from "react";
import { track } from "../features/analytics/tracker";

export default function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");       // "", "loading", "success", "error"
  const [message, setMessage] = useState("");
  const fieldId = useId();
  const hpId = useId(); // honeypot

  useEffect(() => {
    if (status === "success" || status === "error") {
      const t = setTimeout(() => setStatus(""), 4000);
      return () => clearTimeout(t);
    }
  }, [status]);

  const handleSubscribe = async (e) => {
    e?.preventDefault?.();
    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      setStatus("error");
      setMessage("Enter a valid email.");
      return;
    }

    // Honeypot guard
    const hp = document.getElementById(hpId)?.value;
    if (hp) return;

    try {
      setStatus("loading");
      const res = await fetch("https://teardrophydro.co.uk/garageFarm/newsletter", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      if (res.ok) {
        setStatus("success");
        setMessage("You're subscribed!");
        setEmail("");
        track?.("newsletter_signup", { source: "inline" });
      } else {
        setStatus("error");
        setMessage("Something went wrong. Please try again.");
      }
    } catch {
      setStatus("error");
      setMessage("Network error. Please try again.");
    }
  };

  return (
    <form className="nl-wrap" onSubmit={handleSubscribe} noValidate>
      <div className="nl-copy">
        <h3 className="h2">Harvest updates</h3>
        <p className="muted">Subscribe to our newsletter for information about new varieties, availability, and drops!</p>
      </div>

      <div className="nl-controls">
        <label htmlFor={fieldId} className="sr-only">Email address</label>
        <input
          id={fieldId}
          type="email"
          inputMode="email"
          autoComplete="email"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={`nl-input ${status === "error" ? "is-error" : ""}`}
          aria-invalid={status === "error"}
        />
        <button className="btn btn-primary nl-btn" disabled={status === "loading"}>
          {status === "loading" ? "Subscribing…" : "Subscribe"}
        </button>
        {/* honeypot */}
        <input id={hpId} type="text" tabIndex="-1" autoComplete="off" className="hp-field" />
      </div>

      {status && message && (
        <div className={`nl-msg ${status}`}>
          {message}
        </div>
      )}
    </form>
  );
}
